import React from "react"
import { Table, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableBody } from "material-ui"
import { EPunchStage, EPunchValidationType, IPunchResult } from "../../../models"
import strings from "../../../localization/strings"
import ErrorIcon from "material-ui/svg-icons/alert/error"
import SuccessIcon from "material-ui/svg-icons/action/check-circle"
import PunchResultDetailCol from "./PunchResultDetailCol"
import { green500, red500 } from "material-ui/styles/colors"
interface IProps {
	isGlobalPunch: boolean
	stage: EPunchStage
	results: IPunchResult[]
}

const PunchResultTable: React.SFC<IProps> = (props: IProps) => {
	const errorCount = props.results.filter(i => i.Type !== EPunchValidationType.Valid).length
	return (
		<Table selectable={false}>
			<TableHeader
				displaySelectAll={false}
				adjustForCheckbox={false}
				enableSelectAll={false}
			>
				<TableRow style={{ height: 40 }}>
					<TableHeaderColumn style={{ display: "flex", alignItems: "center", padding: 0, height: 40 }}>
						{errorCount ?
							<ErrorIcon style={{ color: red500, width: 25, height: 25, marginRight: 5 }} /> :
							<SuccessIcon style={{ color: green500, width: 25, height: 25, marginRight: 5 }} />
						}
						<span>{props.stage === EPunchStage.CheckValidate ? strings.Punch_Data_Validation_Issues : strings.Execution_Results}</span>
						{props.isGlobalPunch && props.stage === EPunchStage.Execution &&
							<span style={{ marginLeft: 25 }}>{`${strings.Success}: ${props.results.length - errorCount},  ${strings.Error}: ${errorCount}`}</span>
						}
					</TableHeaderColumn>
					<TableHeaderColumn style={{ padding: 0, height: 40, width: 50, textAlign: "center" }}>{strings.Details}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody displayRowCheckbox={false}>
				{props.results.map((result, index) =>
					<TableRow key={index} style={{ height: 30, borderBottom: "none" }}>
						<TableRowColumn style={{ padding: 0, height: 30, color: props.stage === EPunchStage.Execution && result.Type !== EPunchValidationType.Valid && "red" }}>
							{`${index + 1}) ${result.Type === EPunchValidationType.Valid ? strings.Success : strings.Error}: ${result.Title}`}
						</TableRowColumn>
						<TableRowColumn style={{ padding: 0, height: 30, width: 50, textAlign: "center" }}>
							<PunchResultDetailCol
								result={result}
								orderKey={String(index)}
							/>
						</TableRowColumn>
					</TableRow>
				)}
			</TableBody>
		</Table>
	)
}

export default PunchResultTable